import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ValidationPatternConstants } from 'src/app/constants/ValidationPattern.constants';
import { IdmClientSecretAutoRotationConfig } from 'src/app/models/graph/applications/IdmClientSecretAutoRotationConfig';
import { ChevronApplicationService } from 'src/app/services/application/ChevronApplication.service';
import { PageLayout } from '@cvx/nextpage';

@Component({
  selector: 'create-client-secret-auto-rotation-config-form',
  standalone: false,
  templateUrl: './create-client-secret-auto-rotation-config-form.component.html',
  styleUrl: './create-client-secret-auto-rotation-config-form.component.css'
})
export class CreateClientSecretAutoRotationConfigFormComponent implements OnChanges {

  constructor(private chevronAppService: ChevronApplicationService, private readonly formBuilder: FormBuilder) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.serviceId = changes.serviceId.currentValue;
    this.appId = changes.appId.currentValue;
    this.requiredAppIdSuffix = `${this.appIdPrefix}${this.appId}`;
    this.truncatedAppIdSuffix = this.requiredAppIdSuffix.substring(0, this.appIdSuffixDisplayLength);
    this.search();
  }

  PageLayout = PageLayout;

  readonly clientSecretAutoRotationConfigLink: string = 'https://go.chevron.com/appReg-ClientSecretAutoRotationConfig';
  readonly appIdPrefix: string = '-appsecret-';
  readonly appIdLength: number = 36;
  readonly appIdSuffixDisplayLength: number = 25; // Display only the first # of characters of the appId suffix

  configForm = this.formBuilder.group({
    keyvaultName: [
      '',
      Validators.compose([
        Validators.required
      ]),
    ],
    keyvaultSecretName: [
      '',
      Validators.compose([
        Validators.required,
        Validators.maxLength(127 - this.appIdPrefix.length - this.appIdLength),
        Validators.pattern(ValidationPatternConstants.KeyVaultSecretNamePattern),
      ]),
    ],
  });

  chevronApp: any = null;
  associatedKeyvaultNames: string[] = [];
  selectedKeyvaultName: string = '';
  keyvaultConfigsErrorMessage: string;

  @Input() showTitle: boolean = true;
  @Input() isDialog: boolean = false;
  @Input() serviceId: string = '';
  @Input() makeSticky: boolean = false;
  @Input() appId: string = '';

  @Output() newIdmClientSecretAutoRotationConfig = new EventEmitter<IdmClientSecretAutoRotationConfig[]>();
  @Output() cancelled = new EventEmitter<{ cancelled: boolean }>();

  isSearching: boolean = true;
  screenMessage: string = '';


  requiredAppIdSuffix: string = `${this.appIdPrefix}${this.appId}`;
  truncatedAppIdSuffix: string = this.requiredAppIdSuffix.substring(0, this.appIdSuffixDisplayLength);

  keyvaultConfigsDisplayedColumns: string[] = ['keyvaultName', 'secretName'];
  newClientSecretAutoRotationConfig: IdmClientSecretAutoRotationConfig[] = [];

  get keyvaultSecretName() { return this.configForm.get('keyvaultSecretName')?.value ?? ''; }

  search() {
    if (this.serviceId?.length > 0) {
      this.isSearching = true;
      this.screenMessage = '';
      this.chevronAppService.GetApplicationAsync(this.serviceId).then((app) => {
        this.chevronAppService.GetAssociatedKeyvaultNamesAsync(this.serviceId).then((keyvaultNames) => {
          this.associatedKeyvaultNames = keyvaultNames.data;
          this.chevronApp = {
            serviceId: app.data.serviceId,
            displayName: app.data.displayName
          };
        })
          .catch((err) => {
            this.screenMessage = err.statusText;
          })
          .finally(() => {
            this.isSearching = false;
          });;
      })
        .catch((err) => {
          this.screenMessage = err.statusText;
          this.isSearching = false;
        });
    }
    else {
      this.screenMessage = 'Service Id is not set';
      this.isSearching = false;
    }
  }

  saveConfig() {
    if (this.newClientSecretAutoRotationConfig.length > 0) {
      this.newIdmClientSecretAutoRotationConfig.emit(this.newClientSecretAutoRotationConfig);
    }
  }

  addConfig() {

    if (this.configForm.invalid) {
      return;
    }
    const finalNewSecretName = `${this.keyvaultSecretName}${this.requiredAppIdSuffix}`;
    if (this.newClientSecretAutoRotationConfig.findIndex(o => o.keyvaultName == this.selectedKeyvaultName && o.secretName == finalNewSecretName) > -1) {
      // show error message
      this.keyvaultConfigsErrorMessage = "the confg has already been added";
      return;
    }

    // reset error message
    this.keyvaultConfigsErrorMessage = "";
    const newConfig = new IdmClientSecretAutoRotationConfig(this.selectedKeyvaultName, finalNewSecretName);
    this.newClientSecretAutoRotationConfig = [...this.newClientSecretAutoRotationConfig, newConfig];
  }

  keyvaultSelectionChanged(event: any) {
    this.selectedKeyvaultName = event.value;
    this.configForm.patchValue({
      keyvaultName: this.selectedKeyvaultName
    })
  }

  removeConfig(config: IdmClientSecretAutoRotationConfig) {
    this.newClientSecretAutoRotationConfig = this.newClientSecretAutoRotationConfig.filter((n) => n.id !== config.id);
  }
}
